namespace TabAurous.OMS {
    export interface ContactDetailsRow {
        ContactId?: number;
        LedgerId?: number;
        Designation?: number;
        FirstName?: string;
        LastName?: string;
        EmailId?: string;
        Phone?: string;
        MobileNo?: string;
        IsDefault?: boolean;
        AddtoZiFlow?: boolean;
        Comment?: boolean;
        Decision?: boolean;
        Manage?: boolean;
        Share?: boolean;
    }

    export namespace ContactDetailsRow {
        export const idProperty = 'ContactId';
        export const nameProperty = 'FirstName';
        export const localTextPrefix = 'OMS.ContactDetails';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            ContactId = "ContactId",
            LedgerId = "LedgerId",
            Designation = "Designation",
            FirstName = "FirstName",
            LastName = "LastName",
            EmailId = "EmailId",
            Phone = "Phone",
            MobileNo = "MobileNo",
            IsDefault = "IsDefault",
            AddtoZiFlow = "AddtoZiFlow",
            Comment = "Comment",
            Decision = "Decision",
            Manage = "Manage",
            Share = "Share"
        }
    }
}
